"use strict";

define('service/legacy',['require','exports','module','backbone','appkit/service','appkit/router','app/app','../layout/legacy.layout','../langs'],function (require, exports, module) {
  var Backbone = require('backbone'),
    Service = require('appkit/service'),
    Router = require('appkit/router'),
    LegacyApp = require('app/app'),
    LegacyLayout = require('../layout/legacy.layout'),
    langs = require('../langs');
  var LegacyService = Service.extend({
    inject: ['layout'],
    events: {
      'app:start': 'onAppStart',
      'resize:menu': 'onResizeMenu',
      'authenticated': 'onAuthenticated'
    },
    replies: {
      'legacy:enabled': 'isLegacyEnabled'
    },
    isLegacyEnabled: function isLegacyEnabled() {
      return true;
    },
    onResizeMenu: function onResizeMenu() {
      var distractionFreeMode = this.request('get:distractionFreeMode');
      if (distractionFreeMode) {
        this.legacyLayout.legacy.$el.addClass('distraction-free');
      } else {
        this.legacyLayout.legacy.$el.removeClass('distraction-free');
      }
    },
    onAppStart: function onAppStart() {
      var legacyLayout = this.legacyLayout = new LegacyLayout({
        el: document.body
      });
      legacyLayout.render();
      legacyLayout.main.$el.hide();
      legacyLayout.main.show(this.layout);
      legacyLayout.legacy._ensureElement();
      this.app.registerSingleton('legacyLayout', legacyLayout);
      var legacyApp = this.legacyApp = window.legacyApp = this.app.legacyApp = LegacyApp.start(legacyLayout.legacy.$el);
      window.legacyLayout = this.legacyLayout;
      this.app.registerSingleton('legacyApp', legacyApp);
      legacyApp.topMenu = this.app.topMenu;
      this.listenToOnce(legacyApp.getAuthenticateController(), 'authenticated', function (user) {
        this.channel.trigger('authenticated', user);
      });
      this.listenTo(Backbone.history, 'route', this.onRoute);
    },
    onAuthenticated: function onAuthenticated() {
      this.moveHeader(false);
    },
    moveHeader: function moveHeader(isLegacy) {
      var topMenu = this.channel.request('top:menu');
      var productMenu = this.channel.request('product:menu');
      if (isLegacy) {
        app.title = langs.phrase('App.Title');
        this.legacyLayout.main.currentView.content.show(new Backbone.View());
        this.legacyLayout.main.$el.hide();
        this.legacyLayout.legacy.$el.show();
        var legacyContentEl = this.legacyApp.getView().getContentElement(),
          legacyHeaderEl = this.legacyApp.getView().getHeaderElement();
        legacyHeaderEl.append(topMenu.$el);
        legacyHeaderEl.append(productMenu.$el);
      } else {
        this.legacyLayout.legacy.$el.hide();
        this.legacyLayout.main.$el.show();
        this.legacyLayout.main.currentView.header.trigger('show');
        this.layout.header.$el.append(topMenu.$el);
        this.layout.header.$el.append(productMenu.$el);
      }
      app.request('resize:menu');
    },
    onRoute: function onRoute(router, name) {
      var isLegacy = !(router instanceof Router);
      this.moveHeader(isLegacy);
    }
  });
  module.exports = LegacyService;
});

